import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function CountryStatusReducer(
	state = initialState.countryStatus,
	action
) {
	switch (action.type) {
		case types.GET_COUNTRY_STATUS: {
			return action.response;
		}
		default:
			return state;
	}
}
